import {
  exceptionApi,
  TCreateExceptionPayload,
  TUpdateExceptionPayload,
} from 'onboarding/api/exceptionApi'

class ExceptionService {
  public getExceptionsRequestsListCrud(cacheKey: string) {
    return exceptionApi.getExceptionsRequestsListCrud(cacheKey)
  }

  public getListGroupsCrud() {
    return exceptionApi.getListGroupsCrud()
  }

  public clearCacheListGroupsCrud(needTriggerSubscribers?: boolean) {
    return exceptionApi.clearCacheListGroupsCrud(needTriggerSubscribers)
  }

  public listGroups() {
    return exceptionApi.listGroups()
  }

  public create(payload: TCreateExceptionPayload) {
    return exceptionApi.create(payload)
  }

  public update(code: string, type: string, payload: TUpdateExceptionPayload) {
    return exceptionApi.update(code, type, payload)
  }

  public deleteOne(code: string, type: string): Promise<boolean> {
    return exceptionApi.deleteOne(code, type)
  }
}

export const exceptionService = new ExceptionService()
